import { Box, Typography, Chip, Button, Divider } from "@mui/material";
import { LocalShipping, Settings, CloudDownload, CheckCircle, Warning } from "@mui/icons-material";

const ExpedicaoHeader = ({ bridgeConnected, selectedPrinter, onConfigurePrinter, onInstallBridge }) => {
  return (
    <Box
      sx={{
        backgroundColor: "white",
        p: 3,
        borderBottom: "1px solid rgba(0,0,0,0.1)",
        position: "relative"
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "3px",
          background: "linear-gradient(90deg, #FF7322 0%, #ff9800 50%, #FF7322 100%)",
          backgroundSize: "200% 100%",
          animation: "shimmer 3s linear infinite"
        }}
      />
      <style jsx global>{`
        @keyframes shimmer {
          0% { background-position: -200% 0; }
          100% { background-position: 200% 0; }
        }
      `}</style>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%"
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2
          }}
        >
          <LocalShipping
            sx={{
              color: "#FF7322",
              fontSize: "2rem"
            }}
          />
          <Box>
            <Typography
              variant="h5"
              sx={{
                fontWeight: 600,
                color: "#333",
                mb: 0.5
              }}
            >
              Expedição
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: "#666"
              }}
            >
              Impressão de etiquetas de transporte para expedição
            </Typography>
          </Box>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, minWidth: '300px' }}>
          {bridgeConnected ? (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                bgcolor: 'rgba(76, 175, 80, 0.06)',
                borderRadius: 2,
                px: 2,
                py: 1,
                border: '1px solid rgba(76, 175, 80, 0.15)',
                boxShadow: '0 2px 8px rgba(76, 175, 80, 0.08)',
                transition: 'all 0.2s ease'
              }}
            >
              <Chip
                icon={<CheckCircle />}
                label="Bridge Online"
                color="success"
                variant="filled"
                size="small"
                sx={{
                  fontWeight: 600,
                  fontSize: '0.75rem',
                  height: 26,
                  '& .MuiChip-icon': {
                    fontSize: '0.9rem'
                  }
                }}
              />

              <Divider orientation="vertical" flexItem sx={{ borderColor: "rgba(76, 175, 80, 0.3)" }} />

              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 0.3 }}>
                {selectedPrinter && (
                  <Typography
                    variant="caption"
                    sx={{
                      color: '#388e3c',
                      fontSize: '0.7rem',
                      fontWeight: 500,
                      lineHeight: 1
                    }}
                  >
                    📄 {selectedPrinter.name || selectedPrinter}
                  </Typography>
                )}

                <Button
                  variant="text"
                  color="success"
                  size="small"
                  startIcon={<Settings sx={{ fontSize: '0.8rem' }} />}
                  onClick={onConfigurePrinter}
                  sx={{
                    fontWeight: 500,
                    textTransform: "none",
                    fontSize: "0.7rem",
                    minWidth: "auto",
                    px: 1,
                    py: 0.3,
                    height: 'auto',
                    minHeight: 20,
                    color: '#388e3c',
                    '&:hover': {
                      bgcolor: 'rgba(76, 175, 80, 0.08)',
                      transform: 'translateY(-1px)'
                    }
                  }}
                >
                  Configurar impressora
                </Button>
              </Box>
            </Box>
          ) : (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                bgcolor: 'rgba(244, 67, 54, 0.04)',
                borderRadius: 2,
                px: 2,
                py: 1,
                border: '1px solid rgba(244, 67, 54, 0.15)',
                boxShadow: '0 2px 8px rgba(244, 67, 54, 0.08)',
                transition: 'all 0.2s ease'
              }}
            >
              <Chip
                icon={<Warning />}
                label="Bridge Offline"
                color="error"
                variant="filled"
                size="small"
                sx={{
                  fontWeight: 600,
                  fontSize: '0.75rem',
                  height: 26,
                  '& .MuiChip-icon': {
                    fontSize: '0.9rem'
                  }
                }}
              />

              <Divider orientation="vertical" flexItem sx={{ borderColor: "rgba(244, 67, 54, 0.3)" }} />

              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 0.3 }}>
                <Button
                  variant="contained"
                  color="error"
                  size="small"
                  startIcon={<CloudDownload sx={{ fontSize: '0.8rem' }} />}
                  onClick={onInstallBridge}
                  sx={{
                    fontWeight: 500,
                    textTransform: "none",
                    fontSize: "0.7rem",
                    minWidth: "auto",
                    px: 1.5,
                    py: 0.3,
                    height: 'auto',
                    minHeight: 22,
                    boxShadow: '0 1px 4px rgba(244, 67, 54, 0.2)',
                    '&:hover': {
                      boxShadow: '0 2px 8px rgba(244, 67, 54, 0.3)',
                      transform: 'translateY(-1px)'
                    }
                  }}
                >
                  Instalar Bridge
                </Button>
                <Typography
                  variant="caption"
                  sx={{
                    color: '#d32f2f',
                    fontSize: '0.7rem',
                    fontWeight: 500,
                    lineHeight: 1
                  }}
                >
                  🔌 Impressão ZPL indisponível
                </Typography>
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default ExpedicaoHeader;